// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3YggD","buttons":"PendingPaymentAlert_buttons__G_E5n"};